import {
    Box,
    Header,
    Heading,
    Paragraph,
    PageContent,
} from "grommet";
import { AppPage } from "../components/app-page";
import React, { PropsWithChildren } from "react";
import TwoPeople from "../images/two-people.png";
import { CaseyImage } from "../components/casey-image";

// font color rgba(29, 142, 66, 1) (green)
// background rgba(34, 34, 34, 1) (black/grey)

// font color rgba(246, 232, 214, 1)
// background rgba(29, 142, 66, 1) (green)

// lighter green fill: rgb(125, 168, 99);
// lightest green: fill: rgb(191, 200, 155);

// font rgba(255, 102, 49, 1) (orange)


//font Bogam Weight 600 Normal

const Home: React.FC<PropsWithChildren> = () => {
    const twoPeopleRepeat = new Array(20).fill(
        <CaseyImage
            src={TwoPeople}
            style={{ width: "100px" }}
            alignSelf="center"
            margin="xsmall"
        />);


    return (
        <AppPage>
            <>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'charcoal' }}>
                    <Box align="center" direction="column" pad={{ horizontal: "xsmall", vertical: "large" }}>
                        <Header direction="column" gap="small" overflow="hidden" className="title">
                            <Heading className="title" weight="normal" margin="none">10</Heading>
                            <Heading className="title" weight="normal" margin="none">MORE</Heading>
                            <Heading className="title" weight="normal" margin="none">YEARS</Heading>
                        </Header>
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'green_background' }} pad="small">
                    <Box align="center" direction="row" justify="center" height="small" overflow="hidden">
                        {twoPeopleRepeat}
                    </Box>
                </PageContent>
                <PageContent overflow="hidden" background={{ fill: 'horizontal', color: 'orange' }}>
                    <Box align="center" pad="medium">
                        <Box direction="row">
                        </Box>

                        <Paragraph color="cream_constant" textAlign="center">
                            We fear it is time to stop running from the law and codify our union.
                            Please join us (Purnam and Julia) in legalizing our marriage in the woods among fae and friends.
                        </Paragraph>

                        <Paragraph color="cream_constant">
                            Click "Menu" above to learn more about the event and RSVP!
                        </Paragraph>
                    </Box>
                </PageContent>
            </>
        </AppPage >
    );
}

export default Home;
